import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export const trackCheckoutWtPayFail = (
  provider: EcommerceSectionNamespace.EEcommercePaymentProvider,
  providerType: string,
  totalValue: number,
  errorMessage: string,
) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.CHECKOUT_WT_PAY_FAIL,
      payment: {
        name: '',
        type: providerType,
        provider: provider,
        value: Math.round((totalValue + Number.EPSILON) * 100) / 100,
      },
      error: {
        status: errorMessage,
      },
      _clear: true,
    }),
  );
};
